var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 26,
    viewBox: "0 0 85 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1141)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 23L2.75 22.9382C4.5 22.8763 8 22.7526 11.5 21.6021C15 20.4516 18.5 18.2744 22 15.861C25.5 13.4476 29 10.7981 32.5 7.53745C36 4.27684 39.5 0.40514 43 1.07667C46.5 1.74819 50 6.96295 53.5 8.92156C57 10.8802 60.5 9.58262 64 9.64599C67.5 9.70936 71 11.1336 74.5 12.8912C78 14.6489 81.5 16.7398 83.25 17.7853L85 18.8308",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4);
export default __webpack_public_path__ + "static/media/frame4.f7e2b51caae59f5a1c9ba4dae5f16808.svg";
export { ForwardRef as ReactComponent };